import MfaLayout from "../../Internal/MfaLayout.vue";

const MfaRoutes = {
    component: MfaLayout,
    children: [
        {
            name: "Enable2FA",
            path: "/enable-2fa",
            component: () => import('./Enable2FA.vue'),
            meta: {
                requiresAuth: true,
                requiresBasic: true,
                requiresPattern: true,
                requiresSenior: true,
                requiresExpert: true,
                requiresProfessional: true
            }
        },
        {
            name: "Reset2FA",
            path: "/reset-2fa",
            component: () => import('./Reset2FA.vue'),
            meta: {
                requiresAuth: true,
                requiresBasic: true,
                requiresPattern: true,
                requiresSenior: true,
                requiresExpert: true,
                requiresProfessional: true
            }
        },
        {
            name: "Disable2FA",
            path: "/disable-2fa",
            component: () => import('./Disable2FA.vue'),
            meta: {
                requiresAuth: true,
                requiresBasic: true,
                requiresPattern: true,
                requiresSenior: true,
                requiresExpert: true,
                requiresProfessional: true
            }
        },
        {
            name: "TwoFactorAuthentication",
            path: "/config-2fa",
            component: () => import('./TwoFactorAuthentication.vue'),
            meta: {
                requiresAuth: true,
                requiresBasic: true,
                requiresPattern: true,
                requiresSenior: true,
                requiresExpert: true,
                requiresProfessional: true
            }
        },
        {
            name: "GenerateRecoveryCodes",
            path: "/recovery-2fa",
            component: () => import('./GenerateRecoveryCodes.vue'),
            meta: {
                requiresAuth: true,
                requiresBasic: true,
                requiresPattern: true,
                requiresSenior: true,
                requiresExpert: true,
                requiresProfessional: true
            }
        },
        {
            name: "Login2FA",
            path: "/login-2fa",
            component: () => import('./Login2FA.vue'),
            meta: {
                requiresAuth: true,
                requiresBasic: true,
                requiresPattern: true,
                requiresSenior: true,
                requiresExpert: true,
                requiresProfessional: true
            }
        }
    ]
};

export default MfaRoutes;
